<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="categoriesService"
    [idKey]="'categoryId'"
></base-index-page>